import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const dynamicFooterData = {
  siteName: {
    en: "LearnQuranEasily",
    ur: "لرن قرآن ایزلی",
    ro: "LearnQuranEasily",
  },
  sections: [
    {
      title: {
        en: "Learn Quran Easily",
        ur: "آسانی سے قرآن سیکھیں",
        ro: "Learn Quran Easily",
      },
      content: {
        en: "With the support of our dedicated team at LearnQuranEasily, We proudly present: Managed under the supervision and guidance of Hafiz Md Wasim Akhtar Kalimi and Maulana Irshad Alam Markazi",
        ur: "LearnQuranEasily کی پرعزم ٹیم کی مدد سے، ہم فخر کے ساتھ پیش کرتے ہیں: حافظ محمد وسیم اختر کلیمی اور مولانا ارشاد عالم مرکزی کی نگرانی اور رہنمائی میں۔",
        ro: "LearnQuranEasily ki team ki madad se, hum fakhr ke sath pesh karte hain: Hafiz Md Wasim Akhtar Kalimi aur Maulana Irshad Alam Markazi ki nigrani mein.",
      },
      button: {
        text: {
          en: "Donate Now",
          ur: "ابھی عطیہ دیں",
          ro: "Donate Now",
        },
        link: "/donate",
      },
    },
    {
      title: {
        en: "Our Address",
        ur: "ہمارا پتہ",
        ro: "Our Address",
      },
      addressUrl: "#",
      address: {
        en: "Islampur, West Bengal, (India)",
        ur: "اسلام پور، مغربی بنگال، (بھارت)",
        ro: "Islampur, West Bengal, (India)",
      },
      phone: "9057203762",
      Join: "Join whatsapp Channel",
    },
    {
      title: {
        en: "Explore Link",
        ur: "روابط دریافت کریں",
        ro: "Explore Link",
      },
      links: [
        {
          text: {
            en: "Home",
            ur: "ہوم",
            ro: "Home",
          },
          icon: "fa-check",
          url: "/",
        },
        {
          text: {
            en: "About Us",
            ur: "ہمارے بارے میں",
            ro: "About Us",
          },
          icon: "fa-check",
          url: "/about",
        },
        {
          text: {
            en: "Our Course",
            ur: "ہمارا کورس",
            ro: "Our Course",
          },
          icon: "fa-check",
          url: "/our-course",
        },
        {
          text: {
            en: "Registration",
            ur: "رجسٹریشن",
            ro: "Registration",
          },
          icon: "fa-check",
          url: "/student-registration",
        },
        {
          text: {
            en: "Career Form",
            ur: "کیریئر فارم",
            ro: "Career Form",
          },
          icon: "fa-check",
          url: "/career-form",
        },
        {
          text: {
            en: "Our Leader",
            ur: "ہمارا لیڈر",
            ro: "Our Leader",
          },
          icon: "fa-check",
          url: "/our-leader",
        },
        {
          text: {
            en: "Contact Us",
            ur: "ہم سے رابطہ کریں",
            ro: "Contact Us",
          },
          icon: "fa-check",
          url: "/contact",
        },
        {
          text: {
            en: "Donate",
            ur: "عطیہ دیں",
            ro: "Donate",
          },
          icon: "fa-check",
          url: "/donate",
        },
      ],
    },
    {
      title: {
        en: "Latest Course",
        ur: "تازہ ترین کورسز",
        ro: "Latest Course",
      },
      posts: [
        {
          image:
            "https://lqe-assets.learnquraneasily.in/1747062850492_Bahar_e_shariyat.png",
          class_length_minute: {
            en: "Class Length:30 Minutes",
            ur: "30 منٹ",
            ro: "30 Minutes",
          },
          duration_in_month: {
            en: "Duration:6 Months",
            ur: "6 مہینے",
            ro: "6 Months",
          },
          date: "01 Jan 2045",
          title: {
            en: "Basic of Islam Course",
            ur: "اسلام کی بنیادی تعلیمات کورس",
            ro: "Basic of Islam Course",
          },
          link: "#",
        },
        {
          image: "https://lqe-assets.learnquraneasily.in/1747062510593_Urdu.png",
          class_length_minute: {
            en: "30 Minutes",
            ur: "30 منٹ",
            ro: "30 Minutes",
          },
          duration_in_month: {
            en: "2/4 Years",
            ur: "2/4 سال",
            ro: "2/4 Years",
          },
          date: "01 Jan 2045",
          title: {
            en: "Hifz-e-Quran Course",
            ur: "حفظ قرآن کورس",
            ro: "Hifz-e-Quran Course",
          },
          link: "#",
        },
      ],
    },
  ],
};

class Footer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      lang: ''
    };
  }


  componentDidMount() {
    const storedLangSlug = localStorage.getItem("siteLanguage") || 'en';
    this.setState({ lang: storedLangSlug });
    console.warn(storedLangSlug);

  }
  render() {
    // const { footerData } = this.props;
    // const { lang } = this.state;
    const footerData = dynamicFooterData;

    // if (!footerData) {
    //   return <div>Loading...</div>;
    // }

    return (
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.1s">
        <div className="container py-3">
          {/* Newsletter Section */}
          {/* <div className="row py-5">
            <div className="col-lg-7">
              <h1 className="text-light mb-0">Subscribe our newsletter</h1>
              <p className="text-secondary">Get the latest news and other tips</p>
            </div>
            <div className="col-lg-5">
              <div className="position-relative mx-auto">
                <input className="form-control border-0 w-100 py-3 ps-4 pe-5" type="text" placeholder="Your email" />
                <button type="button" className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 mx-1">Subscribe</button>
              </div>
            </div>
            <div className="col-12">
              <div className="border-top border-secondary"></div>
            </div>
          </div> */}

          {/* Footer Inner Section */}
          <div className={`row g-4 footer-inner ${this.state.lang === "ur" ? "direction-rtl" : ""}`}>
            {footerData.sections.map((section, index) => {
              if (section.title.en === "Our Address") {
                return (
                  <div className="col-md-6 col-lg-6 col-xl-3" key={index}>
                    <div className="footer-item mt-5">
                      <h4 className="text-light mb-4">{section.title[this.state.lang]}</h4>
                      <div className="d-flex flex-column">
                        <h6 className="text-body mb-0">{this.state.lang === 'ur' ? 'ہمارا پتہ' : 'Our Address'}</h6>
                        <div className="d-flex align-items-center border-bottom py-2">
                          <span className="flex-shrink-0 btn-square bg-primary mx-2 p-4">
                            <i className="fa fa-map-marker-alt text-white"></i>
                          </span>
                          <a href={section.addressUrl} className="text-body">{section.address[this.state.lang]}</a>
                        </div>
                        <h6 className="text-body mt-4 mb-0">{this.state.lang === 'ur' ? 'ہمارا موبائل' : 'Our Mobile'}</h6>
                        <div className="d-flex align-items-center py-2 border-bottom">
                          <span className="flex-shrink-0 btn-square bg-primary mx-2 p-4">
                            <i className="fa fa-phone-alt text-white"></i>
                          </span>
                          <a href={`tel:${section.phone}`} className="text-body">{section.phone}</a>
                        </div>
                        <h6 className="text-body mt-4 mb-0">{this.state.lang === 'ur' ? 'ہمارا واٹس ایپ چینل جوائن کریں' : 'Join WhatsApp Channel'}</h6>
                        <div className="d-flex align-items-center py-2">
                          <span className="flex-shrink-0 btn-square bg-primary mx-2 p-4">
                            <i className="fab fa-whatsapp text-white"></i>

                          </span>
                          <a href="https://whatsapp.com/channel/0029VbAIwIsGJP8BlSM3Ua0Y" className="link-whatsapp-channel" target="_blank" rel="noopener noreferrer">Join WhatsApp Channel</a>

                        </div>
                      </div>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div className="col-md-6 col-lg-6 col-xl-3" key={index}>
                    <div className="footer-item mt-5">
                      <h4 className="text-light mb-4">{section.title[this.state.lang]}</h4>
                      {section.content && (
                        <p className="mb-4 text-body">{section.content[this.state.lang]}</p>
                      )}
                      {section.button && (
                        <a href={section.button.link} className="btn btn-primary py-2 px-4">{section.button.text[this.state.lang]}</a>
                      )}
                      {section.links && (
                        <div className="d-flex flex-column align-items-start">
                          {section.links.map((link, i) => (
                            <a key={i} className="text-body mb-2" href={link.url}>
                              <i className={`fa ${link.icon} text-primary mx-1`}></i>{link.text[this.state.lang]}
                            </a>
                          ))}
                        </div>
                      )}
                      {section.posts && (
                        <div className="d-flex flex-column">
                          {section.posts.map((post, i) => (
                            <div className="d-flex py-4" key={i}>
                              <img src={post.image} className="img-fluid_footer flex-shrink-0" alt={post.title} style={{ width: "90px" }} />
                              <div className="px-2">
                                <a href={post.image} className="text-body">{post.title[this.state.lang]}</a>
                                {/* <p className="mb-0 text-body">{post.title}</p> */}
                                <p className="mb-0 text-body">{post.class_length_minute[this.state.lang]}</p>
                                <p className="mb-0 text-body">{post.duration_in_month[this.state.lang]}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="container py-4">
          <div className="border-top border-secondary pb-4"></div>
          <div className="row">
            <div className="col-12 text-center text-white">
              Copyright &copy; 2025 <Link className="border-bottom text-body" to="/">{footerData.siteName[this.state.lang]}</Link>. All Right Reserved.
            </div>
            {/* <div className="col-md-6 text-center text-md-end">
              Developed By <Link className="border-bottom text-body" to="https://jilani.tech">Jilani Tech</Link>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
